import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions, TCustomUseQueryMeta } from 'core/query/type'
import {
  TGetRewardMyRewardsListParams,
  TGetRewardMyRewardsListResponse,
  getRewardMyRewardsList,
  TGetRewardMyTasksListParams,
  TGetRewardMyTasksListResponse,
  getRewardMyTasksList,
  TPostRewardTaskReceiveParams,
  TPostRewardTaskReceiveResponse,
  postRewardTaskReceive,
  TGetRewardTlimitedActivityListParams,
  TGetRewardTlimitedActivityListResponse,
  getRewardTlimitedActivityList,
  TGetRewardTrialInterfaceParams,
  TGetRewardTrialInterfaceResponse,
  getRewardTrialInterface,
  TGetRewardTasksListParams,
  TGetRewardTasksListResponse,
  getRewardTasksList,
  TPostRewardMyRewardsUseParams,
  TPostRewardMyRewardsUseResponse,
  postRewardMyRewardsUse,
  TGetRewardMytasksAmountParams,
  TGetRewardMytasksAmountResponse,
  getRewardMytasksAmount,
  TGetRewardRandomCompletedtasksParams,
  TGetRewardRandomCompletedtasksResponse,
  getRewardRandomCompletedtasks,
  TGetRewardTasksAmountParams,
  TGetRewardTasksAmountResponse,
  getRewardTasksAmount,
  TGetRewardTasksDetailParams,
  TGetRewardTasksDetailResponse,
  getRewardTasksDetail,
  TGetRewardFutureCardStatusParams,
  TGetRewardFutureCardStatusResponse,
  getRewardFutureCardStatus,
  TGetV1RewardTasksAmountParams,
  TGetV1RewardTasksAmountResponse,
  getV1RewardTasksAmount,
  TGetRewardDailyTasksParams,
  TGetRewardDailyTasksResponse,
  getRewardDailyTasks,
  TGetRewardDpttradeTasksParams,
  TGetRewardDpttradeTasksResponse,
  getRewardDpttradeTasks,
  TGetRewardMyTasksRecordParams,
  TGetRewardMyTasksRecordResponse,
  getRewardMyTasksRecord,
  TPostRewardReceiveMyRewardParams,
  TPostRewardReceiveMyRewardResponse,
  postRewardReceiveMyReward,
  TPostRewardActivityApplyParams,
  TPostRewardActivityApplyResponse,
  postRewardActivityApply,
  TGetRewardDpttradeReleaseCardParams,
  TGetRewardDpttradeReleaseCardResponse,
  getRewardDpttradeReleaseCard,
  TGetRewardBannerActivityListParams,
  TGetRewardBannerActivityListResponse,
  getRewardBannerActivityList,
  TGetRewardExclusiveTasksParams,
  TGetRewardExclusiveTasksResponse,
  getRewardExclusiveTasks,
  TGetRewardActivityParamsParams,
  TGetRewardActivityParamsResponse,
  getRewardActivityParams,
  TGetRewardExistAgentUserParams,
  TGetRewardExistAgentUserResponse,
  getRewardExistAgentUser,
  TPostRewardActivityFirstDepositStatusParams,
  TPostRewardActivityFirstDepositStatusResponse,
  postRewardActivityFirstDepositStatus,
  TPostRewardActivityFirstDepositApplyParams,
  TPostRewardActivityFirstDepositApplyResponse,
  postRewardActivityFirstDepositApply,
  TGetRewardActivityFirstDepositEventParams,
  TGetRewardActivityFirstDepositEventResponse,
  getRewardActivityFirstDepositEvent,
  TPostRewardActivityFirstDepositReceiveParams,
  TPostRewardActivityFirstDepositReceiveResponse,
  postRewardActivityFirstDepositReceive,
} from 'core/service/yapi/hk-web/Reward/api'
// 福利中心
// 我的奖励列表
export const useGetRewardMyRewardsListQuery = (
  params?: TGetRewardMyRewardsListParams,
  options?: TUseQueryOptions<TGetRewardMyRewardsListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardMyRewardsList', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardMyRewardsList(params, options?.meta?.requestOptions),
    select: (res) => res.data.data,
  })
}

// 我的任务列表
export const useGetRewardMyTasksListQuery = (
  params?: TGetRewardMyTasksListParams,
  options?: TUseQueryOptions<TGetRewardMyTasksListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardMyTasksList', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardMyTasksList(params, options?.meta?.requestOptions),
  })
}

// 领取任务
export const usePostRewardTaskReceiveMutation = (
  mutationOptions?: TUseMutationOptions<TPostRewardTaskReceiveResponse, TPostRewardTaskReceiveParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Reward', 'RewardTaskReceive', 'Post'],
    mutationFn: (params?: TPostRewardTaskReceiveParams) =>
      postRewardTaskReceive(params, mutationOptions?.meta?.requestOptions),
  })
}

// 限时活动列表
export const useGetRewardTlimitedActivityListQuery = (
  params?: TGetRewardTlimitedActivityListParams,
  options?: TUseQueryOptions<TGetRewardTlimitedActivityListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardTlimitedActivityList', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardTlimitedActivityList(params, options?.meta?.requestOptions),
  })
}

// 理财体验金相关
export const useGetRewardTrialInterfaceQuery = (
  params?: TGetRewardTrialInterfaceParams,
  options?: TUseQueryOptions<TGetRewardTrialInterfaceResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardTrialInterface', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardTrialInterface(params, options?.meta?.requestOptions),
  })
}

// 任务列表
export const useGetRewardTasksListQuery = (
  params?: TGetRewardTasksListParams,
  options?: TUseQueryOptions<TGetRewardTasksListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardTasksList', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardTasksList(params, options?.meta?.requestOptions),
  })
}

// 我的奖励使用(或领取，如果卡券需要领取则表示领取[领取是receivePeriod字段大于0])
export const usePostRewardMyRewardsUseMutation = (
  mutationOptions?: TUseMutationOptions<TPostRewardMyRewardsUseResponse, TPostRewardMyRewardsUseParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Reward', 'RewardMyRewardsUse', 'Post'],
    mutationFn: (params?: TPostRewardMyRewardsUseParams) =>
      postRewardMyRewardsUse(params, mutationOptions?.meta?.requestOptions),
  })
}

// 用户已完成任务累计奖励
export const useGetRewardMytasksAmountQuery = (
  params?: TGetRewardMytasksAmountParams,
  options?: TUseQueryOptions<TGetRewardMytasksAmountResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardMytasksAmount', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardMytasksAmount(params, options?.meta?.requestOptions),
  })
}

// 随机获已领取奖励的用户列表
export const useGetRewardRandomCompletedtasksQuery = (
  params?: TGetRewardRandomCompletedtasksParams,
  options?: TUseQueryOptions<TGetRewardRandomCompletedtasksResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardRandomCompletedtasks', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardRandomCompletedtasks(params, options?.meta?.requestOptions),
  })
}

// 生效任务、新手任务累计奖励
export const useGetRewardTasksAmountQuery = (
  params?: TGetRewardTasksAmountParams,
  options?: TUseQueryOptions<TGetRewardTasksAmountResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardTasksAmount', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardTasksAmount(params, options?.meta?.requestOptions),
    select: (res) => res.data.data,
  })
}

// 任务详情
export const useGetRewardTasksDetailQuery = (
  params?: TGetRewardTasksDetailParams,
  options?: TUseQueryOptions<TGetRewardTasksDetailResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardTasksDetail', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardTasksDetail(params, options?.meta?.requestOptions),
    select: (res) => res.data.data,
  })
}

// 合约卡券图标状态
export const useGetRewardFutureCardStatusQuery = (
  params?: TGetRewardFutureCardStatusParams,
  options?: TUseQueryOptions<TGetRewardFutureCardStatusResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardFutureCardStatus', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardFutureCardStatus(params, options?.meta?.requestOptions),
    select: (res) => res.data.data,
  })
}

// 生效任务、新手任务累计奖励
export const useGetV1RewardTasksAmountQuery = (
  params?: TGetV1RewardTasksAmountParams,
  options?: TUseQueryOptions<TGetV1RewardTasksAmountResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'V1RewardTasksAmount', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1RewardTasksAmount(params, options?.meta?.requestOptions),
  })
}

// 福利中心每日任务
export const useGetRewardDailyTasksQuery = (
  params?: TGetRewardDailyTasksParams,
  options?: TUseQueryOptions<TGetRewardDailyTasksResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardDailyTasks', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardDailyTasks(params, options?.meta?.requestOptions),
  })
}

// 福利中心新人交易挑战任务
export const useGetRewardDpttradeTasksQuery = (
  params?: TGetRewardDpttradeTasksParams,
  options?: TUseQueryOptions<TGetRewardDpttradeTasksResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardDpttradeTasks', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardDpttradeTasks(params, options?.meta?.requestOptions),
  })
}

// 我的任务记录
export const useGetRewardMyTasksRecordQuery = (
  params?: TGetRewardMyTasksRecordParams,
  options?: TUseQueryOptions<TGetRewardMyTasksRecordResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardMyTasksRecord', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardMyTasksRecord(params, options?.meta?.requestOptions),
  })
}

// 领取奖励
export const usePostRewardReceiveMyRewardMutation = (
  mutationOptions?: TUseMutationOptions<TPostRewardReceiveMyRewardResponse, TPostRewardReceiveMyRewardParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Reward', 'RewardReceiveMyReward', 'Post'],
    mutationFn: (params?: TPostRewardReceiveMyRewardParams) =>
      postRewardReceiveMyReward(params, mutationOptions?.meta?.requestOptions),
  })
}

// 公告限时活动报名提交
export const usePostRewardActivityApplyMutation = (
  mutationOptions?: TUseMutationOptions<TPostRewardActivityApplyResponse, TPostRewardActivityApplyParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Reward', 'RewardActivityApply', 'Post'],
    mutationFn: (params?: TPostRewardActivityApplyParams) =>
      postRewardActivityApply(params, mutationOptions?.meta?.requestOptions),
  })
}

// 发放新人交易挑战卡券
export const useGetRewardDpttradeReleaseCardQuery = (
  params?: TGetRewardDpttradeReleaseCardParams,
  options?: TUseQueryOptions<TGetRewardDpttradeReleaseCardResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardDpttradeReleaseCard', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardDpttradeReleaseCard(params, options?.meta?.requestOptions),
  })
}

// 福利中心banner配置
export const useGetRewardBannerActivityListQuery = (
  params?: TGetRewardBannerActivityListParams,
  options?: TUseQueryOptions<TGetRewardBannerActivityListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardBannerActivityList', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardBannerActivityList(params, options?.meta?.requestOptions),
  })
}

// 福利中心专属任务
export const useGetRewardExclusiveTasksQuery = (
  params?: TGetRewardExclusiveTasksParams,
  options?: TUseQueryOptions<TGetRewardExclusiveTasksResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardExclusiveTasks', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardExclusiveTasks(params, options?.meta?.requestOptions),
  })
}

// 福利中心活动参数配置
export const useGetRewardActivityParamsQuery = (
  params?: TGetRewardActivityParamsParams,
  options?: TUseQueryOptions<TGetRewardActivityParamsResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardActivityParams', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardActivityParams(params, options?.meta?.requestOptions),
  })
}

// 判断用户是否代理商或旗下
export const useGetRewardExistAgentUserQuery = (
  params?: TGetRewardExistAgentUserParams,
  options?: TUseQueryOptions<TGetRewardExistAgentUserResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardExistAgentUser', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardExistAgentUser(params, options?.meta?.requestOptions),
  })
}

// 限时首充活动报名状态
export const usePostRewardActivityFirstDepositStatusMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostRewardActivityFirstDepositStatusResponse,
    TPostRewardActivityFirstDepositStatusParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Reward', 'RewardActivityFirstDepositStatus', 'Post'],
    mutationFn: (params?: TPostRewardActivityFirstDepositStatusParams) =>
      postRewardActivityFirstDepositStatus(params, mutationOptions?.meta?.requestOptions),
  })
}

// 限时首充活动报名提交
export const usePostRewardActivityFirstDepositApplyMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostRewardActivityFirstDepositApplyResponse,
    TPostRewardActivityFirstDepositApplyParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Reward', 'RewardActivityFirstDepositApply', 'Post'],
    mutationFn: (params?: TPostRewardActivityFirstDepositApplyParams) =>
      postRewardActivityFirstDepositApply(params, mutationOptions?.meta?.requestOptions),
  })
}

// 限时首充活动事件配置
export const useGetRewardActivityFirstDepositEventQuery = (
  params?: TGetRewardActivityFirstDepositEventParams,
  options?: TUseQueryOptions<TGetRewardActivityFirstDepositEventResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Reward', 'RewardActivityFirstDepositEvent', 'GET', ...Object.values(params || {})],
    queryFn: () => getRewardActivityFirstDepositEvent(params, options?.meta?.requestOptions),
  })
}

// 限时首充活动领取提交
export const usePostRewardActivityFirstDepositReceiveMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostRewardActivityFirstDepositReceiveResponse,
    TPostRewardActivityFirstDepositReceiveParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Reward', 'RewardActivityFirstDepositReceive', 'Post'],
    mutationFn: (params?: TPostRewardActivityFirstDepositReceiveParams) =>
      postRewardActivityFirstDepositReceive(params, mutationOptions?.meta?.requestOptions),
  })
}
